import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  auth0OnboardingApiRef,
  Auth0OnboardingClient,
} from '@internal/plugin-auth0-onboarding';
import { feedbackApiRef, FeedbackClient } from '@internal/plugin-feedback';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: auth0OnboardingApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new Auth0OnboardingClient({ discoveryApi, fetchApi }),
  }),
  // The feedback plugin has no page of its own (only the floating button in
  // Root), so nothing mounts it and its own API factory never registers.
  // Register the client here, like the auth0-onboarding one above.
  createApiFactory({
    api: feedbackApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new FeedbackClient({ discoveryApi, fetchApi }),
  }),
];
